import { styleConstants } from '@paywithextend/components'
import React from 'react'
import Tooltip from 'src/components/Tooltip/Tooltip'
import Trns from 'src/localization/Trns'
import { css } from 'styled-components'

interface PhysicalCardTooltipProps {
  openLeft: boolean
}

const PhysicalCardTooltip: React.FC<PhysicalCardTooltipProps> = (
  props,
): React.ReactElement => {
  return (
    <Tooltip openLeft={props.openLeft}>
      <p>
        <Trns
          source={
            '${physicalCards} are exact replicates of a Virtual Card and provide users with a payment method that can be used at point of sale. Physical cards can only be created at the time you create the Virtual Card and any changes you make to your Virtual Card will immediately be reflected on your physical card, including deactivation.'
          }
          expressions={{
            physicalCards: (
              <span
                css={css`
                  font-family: ${styleConstants.fontFamilies.medium};
                `}
              >
                <Trns source={'Physical cards'} />
              </span>
            ),
          }}
        />
      </p>
    </Tooltip>
  )
}

export default PhysicalCardTooltip
